import React, { useEffect, useState } from 'react';
import './topButton.css';

function TopButton() {
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		const scrollContainer = document.querySelector('.page-content');

		const handleScroll = () => {
			const scrollTop = scrollContainer
				? scrollContainer.scrollTop
				: window.scrollY || document.documentElement.scrollTop;

			setIsVisible(scrollTop > 50);
		};

		scrollContainer?.addEventListener('scroll', handleScroll);
		window.addEventListener('scroll', handleScroll);
		handleScroll();

		return () => {
			scrollContainer?.removeEventListener('scroll', handleScroll);
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

	const scrollToTop = () => {
		const scrollContainer = document.querySelector('.page-content');

		if (scrollContainer) {
			scrollContainer.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
			return;
		}

		window.scrollTo({ top: 0, behavior: 'smooth' });
	};

	return (
		<button
			type="button"
			className={`top-button ${isVisible ? 'show' : ''}`}
			onClick={scrollToTop}
			aria-label="Scroll to top"
		>
			↑
		</button>
	);
}

export default TopButton;
